/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('site.responsiveTable', function (el) {
        ResponsiveTable.create(el).run();
    });
    var ResponsiveTable = /** @class */ (function () {
        function ResponsiveTable(el) {
            this.el = el;
        }
        ResponsiveTable.create = function (el) {
            return new ResponsiveTable(el);
        };
        ResponsiveTable.prototype.run = function () {
            var headers = Array.from(this.el.querySelectorAll('.header div')).map(function (el) {
                return el.innerText;
            });
            this.el.querySelectorAll('.course div').forEach(function (td) {
                var label = headers[getElementIndex(td)];
                if (label) {
                    td.setAttribute('data-th', label);
                    if (td.innerHTML.indexOf('<div') === -1) {
                        var div_1 = document.createElement('div');
                        td.childNodes.forEach(function (c) {
                            div_1.appendChild(c);
                        });
                        td.appendChild(div_1);
                    }
                }
            });
            function getElementIndex(element) {
                return Array.from(element.parentNode.children).indexOf(element);
            }
        };
        return ResponsiveTable;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
